import React, { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import pathRouts from "../../../shared/enums/pathRoute";
import postMessageBridgeTypes from "../../../shared/enums/postMessageBridgeTypes";
import IframePage from "../../../shared/components/pages/IframePage/IframePage";
import { selectEntitiesByFilters } from "../../../shared/store/views/entityView";
import { teachingAssistantBotByKey } from "../../../shared/utils/entitiesFiltersUtils";
import { getTab } from "../../../shared/utils/tabsUtils";

const PersonalAssistantBotPage = () => {
    
    const location = useLocation();
    const navigate = useNavigate();
    const { defaultBotKey, iframeUrl, iframeParams } = getTab("bots") ?? {};
    const keyFromUrl = location.pathname.match(new RegExp(`/${pathRouts.BOT}/([^/]+)`))?.[1];
    const botKey = keyFromUrl || defaultBotKey;
    const botFilter = useMemo(() => teachingAssistantBotByKey(botKey), [botKey]);
    const bot = useSelector(state => selectEntitiesByFilters(state, botFilter))?.[0];
    const [iframeSrc, setIframeSrc] = useState(null);
    const skipIframeReloadRef = useRef(false);
    const backToRef = useRef(location.state?.from || `/${pathRouts.HOME}`);

    useEffect(() => {
        if (!keyFromUrl && defaultBotKey)
            navigate(`/${pathRouts.BOT}/${defaultBotKey}`, { replace: true, state: location.state });
    }, [keyFromUrl, defaultBotKey, navigate, location.state]);

    useEffect(() => {
        if (skipIframeReloadRef.current) {
            skipIframeReloadRef.current = false;
            return;
        }
        if (!iframeUrl || !bot?.link) return;
        setIframeSrc(`${iframeUrl}/${bot.link}`);
    }, [iframeUrl, bot?.link]);

    useEffect(() => {
        const onMessage = (event) => {
            if (!event.data || event.data.type !== postMessageBridgeTypes.BOT_PORTAL_NAVIGATE) return;
            const nextKey = event.data.key;
            if (!nextKey || nextKey === botKey) return;
            skipIframeReloadRef.current = true;
            navigate(`/${pathRouts.BOT}/${nextKey}`, { replace: true, state: location.state });
        };
        window.addEventListener("message", onMessage);
        return () => window.removeEventListener("message", onMessage);
    }, [botKey, navigate, location.state]);

    const handleBack = () => {
        navigate(backToRef.current);
    };

    return (
        iframeSrc ?
            <IframePage
                iframeUrl={iframeSrc}
                iframeParams={iframeParams}
                titleKey="bots"
                icon="bot"
                onBack={handleBack}
            />
            : null
    );
};

export default PersonalAssistantBotPage;
